export function isNull(value: any) {
  return value === undefined || value === null;
}

export function isNullOrEmpty(value: any) {
  return value === undefined || value === null || value === "";
}
